import type { Editor, EditorEvents } from "@tiptap/core";

export interface TrackedPosition {
  readonly current: number;
  stop: () => void;
}

export const trackPosition = (editor: Editor, position: number): TrackedPosition => {
  let current = position;
  const handleTransaction = ({ transaction }: EditorEvents["transaction"]) => {
    current = transaction.mapping.map(current);
  };

  editor.on("transaction", handleTransaction);

  return {
    get current() {
      return current;
    },
    stop: () => editor.off("transaction", handleTransaction),
  };
};
